import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const rateApi = createApi({
  reducerPath: "rateApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include", // cookies for auth/session
  }),
  tagTypes: ["Rate"],

  endpoints: (builder) => ({
    /* -------------------- Add new rate -------------------- */
    addRate: builder.mutation({
      query: (data) => ({
        url: "/rates/create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Rate"],
    }),

    /* -------------------- Get all rates -------------------- */
    getAllRates: builder.query({
      query: ({ page = 1, limit = 1000, search = "", active } = {}) => {
        const params = { page, limit, q: search };
        if (typeof active === "boolean") params.active = active;
        return { url: "/rates", params };
      },
      providesTags: ["Rate"],
    }),

    /* -------------------- Get rate by ID -------------------- */
    getRateById: builder.query({
      query: (id) => `/rates/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Rate", id }],
    }),
      getLatestRates: builder.query({
  query: () => "/rates/latest",
  providesTags: ["Rate"],
}),

    /* -------------------- Update rate -------------------- */
    updateRate: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/rates/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: ["Rate"],
    }),

    /* -------------------- Activate / Deactivate -------------------- */
    activateRate: builder.mutation({
      query: (id) => ({
        url: `/rates/${id}/activate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Rate"],
    }),

    deactivateRate: builder.mutation({
      query: (id) => ({
        url: `/rates/${id}/deactivate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Rate"],
    }),

  
  }),
});

export const {
  useAddRateMutation,
  useGetAllRatesQuery,
  useGetLatestRatesQuery,
  useGetRateByIdQuery,
  useUpdateRateMutation,
  useActivateRateMutation,
  useDeactivateRateMutation,
} = rateApi;

export default rateApi;
